export class SearchCostCentreTotalsRequest {
  costCentreId: number;
  soloHijos: boolean;
  anio: number;
  mes: number;
  page: number;
  size: number;

  constructor(data: {
    costCentreId: number;
    soloHijos?: boolean;
    anio?: number;
    mes?: number;
    page?: number;
    size?: number;
  }) {
    this.costCentreId = data.costCentreId;
    this.soloHijos = data.soloHijos;
    this.anio = data.anio || new Date().getFullYear();
    this.mes = data.mes || new Date().getMonth()+1;
    this.page = data.page;
    this.size = data.size;
  }
}
